import SurveyWidget from '@aytm/app/swidget/base/SurveyWidget'

if ('undefined' !== typeof window) {
  window.$SurveyWidget = SurveyWidget
}
